
    import Template from 'ln/template/TemplateManager';
    Template.add( { lv:{
  "video-chapter-control": "<div class=\"chapter-control\"><div js=\"chapteritems\" class=\"items\"></div></div>",
  "video-chapter-item": "<div class=\"chapter-item\" style=\"background-image: url('[[ this.imagePath( previewimage, \"large\", \"png\" ) ]]')\"><div class=\"title\"><span class=\"time\">[[ time ]]</span>[[ text ]]</div></div>"
} } );
